export default {
  greigeFabricOrderDate: 'Greige Fabric Order Date',
  greigeFabricInhouseDate: 'Greige Fabric Inhouse Date',
  dyedFabricInhouseDate: 'Dyed Fabric Inhouse Date',
  printedFabricInhouseDate: 'Printed Fabric Inhouse Date',
  acidWashFabricInhouseDate: 'Acid Wash Fabric Inhouse Date',
  cottonFillingPolyfillOrderInhouseDate:
    'Cotton Filling / Polyfill Order / Inhouse Date',
  AccOrderInhouseDate:
    'Acc. Order / Inhouse Date (Lace. POM POM, Tassel, Buttons, Zips, Beads EMB. Thread ETC.)',
  bulkLotSendApprovalDate: 'Bulk Lot Send / Approval Date',
  ppSampleSendApprovalDate: 'PP Sample Send / Approval Date',
  testingSampleSubmissionDateReportDueDate:
    'Testing Samples Submition Date / Report Due Date',
  pilotRunStartDate: 'Pilot Run Start Date',
  pilotRunFinishDate: 'Pilot Run Finish Date',
  labelsTrimsInhouseDate: 'Labels / Trims Inhouse Date',
  initialCuttingStartDate: 'Initial Cutting Start Date',
  initialCuttingFinishDate: 'Initial Cutting Finish Date',
  quiltingStartDate: 'Quilting Start Date',
  quiltingFinishDate: 'Quilting Finish Date',
  embStartDate: 'EMB. (Hand / Machine / Computer) Start Date',
  embFinishDate: 'EMB. (Hand / Machine / Computer) Finish Date',
  washingStartDate: 'Washing Start Date (If Required)',
  washingFinishDate: 'Washing Finish Date (If Required)',
  recuttingAfterEMBQuiltingStartDate:
    'Recutting After EMB., Quilting Start Date',
  recuttingAfterEMBQuiltingFinishDate:
    'Recutting After EMB., Quilting Finish Date',
  stitchingStartDate: 'Stitching Start Date',
  stitchingFinishDate: 'Stitching Finish Date',
  forwarderBookingDate: 'Forwarder Booking Date',
  packagingInhouseDate: 'Packaging Inhouse Date',
  finishingStart: 'Finishing Start',
  inLineInspectionOfferDate: 'In Line Inspection Offer Date',
  topSampleSendApprovalDate: 'Top Sample Send / Approval Date',
  midLineInspectionOfferDate: 'Mid Line Inspection Offer Date',
  packingStart: 'Packing Start',
  finishingCompleteDate: 'Finishing Complete Date',
  finalInspectionOfferDate: 'Final Inspection Offer Date',
  despatch: 'Despatch',
  handoverDate: 'Handover Date',
  vesselDate: 'Vessel Date',
};
